// @ts-nocheck

export class LuceneResult {
  data: any | null | undefined;

  error: Error | null | undefined;

  constructor(data: any | null | undefined, error: Error | null | undefined) {
    if (error) {
      this.error = error;
    } else {
      this.data = data;
    }
  }

  static ok(data: any) {
    return new LuceneResult(data);
  }

  static error(err: Error) {
    return new LuceneResult(null, err);
  }

  map(mapper: (...args: Array<any>) => any) {
    if (this.isError()) {
      return this;
    }

    try {
      return LuceneResult.ok(mapper(this.getData()));
    } catch (err) {
      return LuceneResult.error(err);
    }
  }

  isError(): boolean {
    return Boolean(this.error);
  }

  getError(): Error | null | undefined {
    return this.error;
  }

  getData(): any | null | undefined {
    return this.data;
  }

  value(): any | Error {
    return this.getError() || this.getData();
  }
}
